import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock } from 'lucide-react';
export function Locations() {
  const locations = [{
    name: 'ZONA T',
    address: 'Cra. 12a #83-23',
    hours: ['Lun-Jue: Cocina hasta 10pm / Bar hasta 12am', 'Vie-Sáb: Cocina hasta 10pm / Bar hasta 1am', 'Dom: Cocina hasta 10pm / Bar hasta 11pm'],
    link: 'https://wa.me/573508108717?text=Hola!%20Quiero%20reservar%20en%20Zona%20T'
  }, {
    name: 'UNICENTRO',
    address: 'Calle 127, Food Corner, Salida 3',
    hours: ['Lun-Mié: 9am - 9:30pm', 'Jue-Sáb: 9am - 10pm', 'Dom y Festivos: 9am - 8pm'],
    link: 'https://wa.me/573508108717?text=Hola!%20Quiero%20reservar%20en%20Unicentro'
  }, {
    name: 'FONTANAR',
    address: 'C.C. Fontanar, Local 202',
    hours: ['Lun-Jue: 9am - 9pm', 'Vie-Sáb: 9am - 10pm', 'Dom: 9am - 8pm'],
    link: 'https://wa.me/573508108717?text=Hola!%20Quiero%20reservar%20en%20Fontanar'
  }, {
    name: 'PARQUE LA COLINA',
    address: 'Tercer piso, The Social Food & Drinks',
    hours: ['Lun-Jue: 9am - 9pm', 'Vie-Sáb: 9am - 10pm', 'Dom: 9am - 8pm'],
    link: 'https://wa.me/573508108717?text=Hola!%20Quiero%20reservar%20en%20La%20Colina'
  }, {
    name: 'SALITRE',
    address: 'Salitre, Bogotá',
    hours: ['Lun-Jue: 9am - 9pm', 'Vie-Sáb: 9am - 10pm', 'Dom: 9am - 8pm'],
    link: 'https://wa.me/573508108717?text=Hola!%20Quiero%20reservar%20en%20Salitre'
  }];
  return <section id="sedes" className="relative py-20 md:py-32" data-id="element-208">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-209">
        <img src="https://cdn.magicpatterns.com/uploads/nR9GuhnKMZU18CAyUTp8BC/ewDFdfadsf.jpg" alt="Fachada Cabrera con letras rojas de neón y arcos en ladrillo" className="w-full h-full object-cover" data-id="element-210" />
        <div className="absolute inset-0 bg-[#0D0600]/85" data-id="element-211"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-cream mb-4" data-id="element-214">
            Visítanos en nuestras 5 Sedes
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-215"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-216">
          {locations.map((loc, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className={`bg-brand-primary/90 backdrop-blur-sm p-8 rounded-2xl border border-brand-gold/20 hover:border-brand-gold hover:shadow-[0_0_20px_rgba(201,168,76,0.15)] transition-all duration-300 flex flex-col ${idx >= 3 ? 'lg:col-span-1 lg:col-start-auto' : ''}`} data-id="element-217">
              <h3 className="text-2xl font-serif text-brand-gold mb-6" data-id="element-218">
                {loc.name}
              </h3>

              <div className="space-y-4 mb-8 flex-grow" data-id="element-219">
                <div className="flex items-start" data-id="element-220">
                  <MapPin size={20} className="text-brand-cream/50 mr-3 mt-1 flex-shrink-0" data-id="element-221" />
                  <p className="text-brand-cream/90" data-id="element-222">{loc.address}</p>
                </div>

                <div className="flex items-start" data-id="element-223">
                  <Clock size={20} className="text-brand-cream/50 mr-3 mt-1 flex-shrink-0" data-id="element-224" />
                  <div className="space-y-1" data-id="element-225">
                    {loc.hours.map((hour, hIdx) => <p key={hIdx} className="text-brand-cream/70 text-sm" data-id="element-226">
                        {hour}
                      </p>)}
                  </div>
                </div>
              </div>

              <a href={loc.link} target="_blank" rel="noreferrer" className="w-full text-center py-3 rounded-full border border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-brand-primary font-semibold text-sm transition-all duration-300" data-id="element-227">
                RESERVAR EN {loc.name}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}